import React, { FC } from 'react';
import { colors } from 'src/config/colors';
import styled, { css } from 'styled-components';
import { StyleProps } from 'src/lib/styleProps';
import { media } from 'src/config/breakpoints';
import { typography } from 'src/config/typography';
import { SimpleLink } from 'src/common/components/SimpleLink';

const Content = styled.div`
  margin-top: 2rem;

  ${media.w.min.px768(css`
    margin-top: 3rem;
  `)}
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.375rem;
`;

const Text = styled.p`
  color: ${colors.blue};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375;
  font-weight: 400;
  margin: 0;
`;

const LocationHeading = styled.h2`
  color: ${colors.pfp3bis};
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1125rem;
  line-height: 1.5;
  margin: 0 0 1rem 0;
`;

const StyledSimpleLink = styled(SimpleLink)`
  text-decoration: none;
`;

export const ContactDetails: FC<StyleProps> = ({ className }) => (
  <Content className={className}>
    <LocationHeading>Szczecin – Centrala</LocationHeading>
    <GridWrapper>
      <Text>
        ul. Monte Cassino 32 <br />
        70-466 Szczecin
      </Text>
      <Text>
        Poniedziałek - Piątek <br />
        Godz: 8:00 - 16:00
      </Text>
      <Text>
        <StyledSimpleLink href="mailto:szkolenia@pfp.com.pl">szkolenia@pfp.com.pl</StyledSimpleLink>
      </Text>
      <Text>
        Dział szkoleń <br />
        +48 91 312 92 22
      </Text>
    </GridWrapper>
  </Content>
);
